import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosFilterPage } from './cronos-filter';

@NgModule({
  declarations: [
    CronosFilterPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosFilterPage),
  ],
})
export class CronosFilterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-filter/cronos-filter.module.ts